import { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import styles from "./SourceConfiguration.module.css";
import { Button, Col, Form, Row } from "react-bootstrap";
import AddBoxIcon from '@mui/icons-material/AddBox';
import { AddSourceConfig, GetSourceDetails } from "../../api/SourceCinfigurationApi/SourceConfigurationApi";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DialogProps } from "../../types/SimpleSearchModel";
import ConfirmationDialog from "../SimpleSearch/ConfirmationDialog";
import { GetAccountByUser, GetActiveFileLocation, GetFolders, GetMetadataColumns } from "../../api/commonApi";
import { FromSourceModel,SourceConfigModel, SubSourceModel } from "../../types/SourceConfigModel";
import { useSnackbar } from "../Common/SnackbarContext";
import LocalStorageUtil from "../../utils/localStorage";

const SourceConfiguration = () => {
    const { showSnackbar } = useSnackbar();
    const { setLoading } = useLoader();
    const [accountName, setAccountName] = useState<any[]>([]);
    const [accountNameId, setAccountNameId] = useState<number>();
    const [inputGroups, setInputGroups] = useState<any[]>([{ sourceName: '', sourceId: 0 }]);
    const [nextStep, setNextStep] = useState(0);
    const [removeSourcelistItem, setRemoveSourceListItem] = useState<any[]>([]);// NOSONAR
    const sourceTypes = [
        {
            id: 1, name: 'PDF'
        },
        {
            id: 2, name: 'Metadata'
        },
        {
            id: 3, name: 'PDF + Metadata'
        },
        {
            id: 4, name: 'PPDF'
        },
        {
            id: 5, name: 'Zip(PDF)'
        },
        {
            id: 6, name: 'Zip(PDF + Metadata)'
        }
    ];
    const [activeFileLocations, setActiveFileLocation] = useState<any[]>([]);// NOSONAR
    const [metadataColumns, setMetadataColumns] = useState<any[]>([]);
    const [selectedAccountName, setSelectedAccountName] = useState<string>();
    const [level, setLevel] = useState<any[]>([]);
    const [totalSourceList, setTotalSourceList] = useState<any[]>([]);

    const [fromSource, setFromSource] = useState<any[]>([{ fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "" }]);

    const [allSourceList, setAllSourceList] = useState<any[]>([{
        txtType: false,
        csvType: false,
        xmlType: false,
        otherType: false,
        otherTxtEnable: true,
        otherFileType: "",
        level1FundFolderId: 0,
        toSourceFileType: 0,
        toSourceFTPLocationID: 0,
        statusFTPLocationId: 0,
        sourceId: 0,
        sourceName: "",
        accountId: 0,
        accountMainSourceid: 0,
        toSourceMetadataDefinitionId: 0,
        isToSourceHeaderAvailable: 0,
        statusFileLocation: false,
        subSourceConfiguration: [{
            subSourceId: 0,
            accountMainSourceId: 0,
            subSourceName: "",
            level1FundFolderId: 0,
            fromSourceType: 0,
            fromSourceLocationId1: 0,
            fromSourceLocationId2: 0,
            fromSourceMetadataDefinitionId: 0,
            toSourceType: 0,
            toSourceFTPLocationId: 0,
            toSourceMetadataDefinitionId: 0,
            isFromSourceHeaderAvailable: "",
            isToSourceHeaderAvailable: "",
            showHideSourceLocation: false,
            showHideSourceMetaData: false,
            showHideHeader: false,
            showHideToSourceMetaData: false,
            showHideToHeader: false,
            panelLevel1Error: ""
        }],
        fromSource: [{ fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "", showHideSourceLocation: false, showHideSourceMetaData: false, showHideHeader: false }],
        showHideToSourceMetaData: false,
        showHideToHeader: false,
        level1Error: "",
        fromSourceTypeError: "",
        fileFormateError: "",
        toSourceMetadataError: "",
        showHideExportLocation: false,
    }]);

    useEffect(() => {
        getAccountName();
    }, []);

    const getAccountName = async () => {
        setLoading(true);
        const payload: any = {
            userId: Number(LocalStorageUtil.getItem("userId")),
        };
        try {
            const accountNameData = await GetAccountByUser(payload);
            setAccountName(accountNameData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    const [dialogProps, setDialogProps] = useState<DialogProps>({
        dialogTitle: "",
        contentText: "",
        confirmText: "",
        closeText: "",
        onConfirm: null,
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [steps, setSteps] = useState([
        { key: 'firstStep', label: 'Source Configuration', isDone: true }
    ]);

    const [activeStep, setActiveStep] = useState(steps[0]);

    const handleNext = () => {
        setSteps([]);
            setNextStep(nextStep + 1);
            const newSteps = [...steps];
            newSteps[0].isDone = false;

            // Iterate over the inputGroups array in reverse order
            for (let i = 0; i <= inputGroups.length - 1; i++) {
                const inputGroup = inputGroups[i];
                 if (inputGroup.sourceName !== '' && i !== 0 && !newSteps.some(step => step.key === inputGroup.sourceName)) {
                    newSteps.push({ key: inputGroup.sourceName, label: inputGroup.sourceName, isDone: true });
                 }
            }

            setSteps(newSteps);
            setActiveStep(newSteps[nextStep + 1]);

             // Check if the value already exists in subAllSystemConfig
        const existingConfig = allSourceList.find(
            (config) => config.sourceName === inputGroups[nextStep+1]?.sourceName
        );

        if (!existingConfig) {
            if (nextStep === 0 || (newSteps.length !== allSourceList.length && newSteps.length > allSourceList.length)) {
                getFolders();
                let newSourceList = [...allSourceList, {
                    txtType: false, 
                    csvType: false, 
                    xmlType: false, 
                    otherType: false, 
                    otherTxtEnable: true, 
                    otherFileType: "", 
                    level1FundFolderId: 0, 
                    toSourceFileType: 0, 
                    toSourceFTPLocationID: 0, 
                    statusFTPLocationId: 0, 
                    sourceId: 0, 
                    sourceName: "", 
                    accountId: 0, 
                    accountMainSourceid: 0, 
                    toSourceMetadataDefinitionId: 0, 
                    isToSourceHeaderAvailable: 0, 
                    statusFileLocation: false,
                    showHideExportLocation: false,
                    subSourceConfiguration:
                        [{
                            subSourceId: 0,
                            accountMainSourceId: 0,
                            subSourceName: "",
                            level1FundFolderId: 0,
                            fromSourceLocationId2: 0,
                            fromSourceMetadataDefinitionId: 0,
                            toSourceMetadataDefinitionId: 0,
                            isFromSourceHeaderAvailable: "",
                            isToSourceHeaderAvailable: "",
                            showHideSourceLocation: false,
                            showHideSourceMetaData: false,
                            showHideHeader: false,
                            showHideToSourceMetaData: false,
                            showHideToHeader: false,
                            panelLevel1Error: ""
                        }], 
                    fromSource: [{ fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "", showHideSourceLocation: false, showHideSourceMetaData: false, showHideHeader: false }], 
                    showHideToSourceMetaData: false, 
                    showHideToHeader: false,
                    level1Error: "", 
                    fromSourceTypeError: "", 
                    fileFormateError: "", 
                    toSourceMetadataError: ""
                    }];
                totalSourceList.forEach((element, index) => {
                newSourceList.push({
                    txtType: false, 
                    csvType: false, 
                    xmlType: false, 
                    otherType: false, 
                    otherTxtEnable: true, 
                    otherFileType: "", 
                    level1FundFolderId: 0, 
                    toSourceFileType: 0, 
                    toSourceFTPLocationID: 0, 
                    statusFTPLocationId: 0, 
                    sourceId: 0, 
                    sourceName: "", 
                    accountId: 0, 
                    accountMainSourceid: 0, 
                    toSourceMetadataDefinitionId: 0, 
                    isToSourceHeaderAvailable: 0, 
                    statusFileLocation: false,
                    showHideExportLocation: false,
                    subSourceConfiguration:
                        [{
                            subSourceId: 0,
                            accountMainSourceId: 0,
                            subSourceName: "",
                            level1FundFolderId: 0,
                            fromSourceLocationId2: 0,
                            fromSourceMetadataDefinitionId: 0,
                            toSourceMetadataDefinitionId: 0,
                            isFromSourceHeaderAvailable: "",
                            isToSourceHeaderAvailable: "",
                            showHideSourceLocation: false,
                            showHideSourceMetaData: false,
                            showHideHeader: false,
                            showHideToSourceMetaData: false,
                            showHideToHeader: false,
                            panelLevel1Error: ""
                        }], 
                    fromSource: [{ fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "", showHideSourceLocation: false, showHideSourceMetaData: false, showHideHeader: false }], 
                    showHideToSourceMetaData: false, 
                    showHideToHeader: false,
                    level1Error: "", 
                    fromSourceTypeError: "", 
                    fileFormateError: "", 
                    toSourceMetadataError: ""
                    })
                });

                totalSourceList.forEach((element, index) => {
                    newSourceList[index + 1].level1FundFolderId = element.level1FundFolderId;
                    newSourceList[index + 1].sourceId = element.sourceId;
                    newSourceList[index + 1].txtType = element.txtType;
                    newSourceList[index + 1].csvType = element.csvType;
                    newSourceList[index + 1].accountId = element.accountId;
                    newSourceList[index + 1].accountMainSourceId = element.accountMainSourceId;
                    newSourceList[index + 1].isToSourceHeaderAvailable = element.isToSourceHeaderAvailable;
                    newSourceList[index + 1].isexporttpExcel = element.isexporttpExcel;
                    newSourceList[index + 1].otherFileType = element.otherFileType;
                    newSourceList[index + 1].statusFTPLocationId = element.statusFTPLocationId;
                    newSourceList[index + 1].statusFileLocation = element.statusFileLocation;
                    newSourceList[index + 1].sourceName = element.sourceName;
                    if(newSourceList[index + 1].statusFileLocation === true) {
                        newSourceList[index + 1].showHideExportLocation = true;
                    };                    
                    newSourceList[index + 1].toSourceFTPLocationID = element.toSourceFTPLocationID;
                    newSourceList[index + 1].toSourceFileType = element.toSourceFileType;
                    newSourceList[index + 1].toSourceMetadataDefinitionId = element.toSourceMetadataDefinitionId;
                    newSourceList[index + 1].xmlType = element.xmlType;
                    if (newSourceList[index + 1].toSourceFileType === 2 || 
                        newSourceList[index + 1].toSourceFileType === 6 || 
                        newSourceList[index + 1].toSourceFileType === 3) {
                            newSourceList[index + 1].showHideToSourceMetaData = true;
                            newSourceList[index + 1].showHideToHeader = true;
                    }
                    else {
                        newSourceList[index + 1].showHideToSourceMetaData = false;
                        newSourceList[index + 1].showHideToHeader = false;
                    }
                    element?.fromSource?.forEach((childElement: any, childIndex: number) => {
                        newSourceList[index + 1].fromSource[childIndex].accountMainSourceId = childElement.accountMainSourceId;
                        newSourceList[index + 1].fromSource[childIndex].fromSourceFileType = childElement.fromSourceFileType;
                        newSourceList[index + 1].fromSource[childIndex].fromSourceId = childElement.fromSourceId;
                        newSourceList[index + 1].fromSource[childIndex].fromSourceLocationId1 = childElement.fromSourceLocationId1;
                        newSourceList[index + 1].fromSource[childIndex].fromSourceLocationId2 = childElement.fromSourceLocationId2;
                        newSourceList[index + 1].fromSource[childIndex].fromSourceMetadataDefinitionId = childElement.fromSourceMetadataDefinitionId;
                        newSourceList[index + 1].fromSource[childIndex].isFromSourceHeaderAvailable = childElement.isFromSourceHeaderAvailable;
                        newSourceList[index + 1].fromSource[childIndex].statusFileLocation = childElement.statusFileLocation;

                        if (newSourceList[index + 1].fromSource[childIndex].fromSourceFileType === 2 || newSourceList[index + 1].fromSource[childIndex].fromSourceFileType === 6) {
                            newSourceList[index + 1].fromSource[childIndex].showHideSourceLocation = false;
                            newSourceList[index + 1].fromSource[childIndex].showHideSourceMetaData = true;
                            newSourceList[index + 1].fromSource[childIndex].showHideHeader = true;
                        } else if (newSourceList[index + 1].fromSource[childIndex].fromSourceFileType === 3) {
                            newSourceList[index + 1].fromSource[childIndex].showHideSourceLocation = true;
                            newSourceList[index + 1].fromSource[childIndex].showHideSourceMetaData = true;
                            newSourceList[index + 1].fromSource[childIndex].showHideHeader = true;
                        }
                    });
                    element?.subSource?.forEach((childElement: any, childIndex: number) => {
                        newSourceList[index + 1].subSourceConfiguration[childIndex].accountMainSourceId = childElement.accountMainSourceId;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceLocationId2 = childElement.fromSourceLocationId2;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceLocationId1 = childElement.fromSourceLocationId1;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceMetadataDefinitionId = childElement.fromSourceMetadataDefinitionId;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].isFromSourceHeaderAvailable = childElement.isFromSourceHeaderAvailable;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].isToSourceHeaderAvailable = childElement.isToSourceHeaderAvailable;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].level1FundFolderId = childElement.level1FundFolderId;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].subSourceId = childElement.subSourceId;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].subSourceName = childElement.subSourceName;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceMetadataDefinitionId = childElement.toSourceMetadataDefinitionId;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceType = childElement.toSourceType;
                        newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceFTPLocationId = childElement.toSourceFTPLocationId;

                        newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceType = childElement.fromSourceType;
                        if (newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceType === 2 || newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceType === 6) {
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideSourceLocation = false;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideSourceMetaData = true;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideHeader = true;
                        } else if (newSourceList[index + 1].subSourceConfiguration[childIndex].fromSourceType === 3) {
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideSourceLocation = true;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideSourceMetaData = true;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideHeader = true;
                        }
                        if (newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceType === 2 || newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceType === 6 || newSourceList[index + 1].subSourceConfiguration[childIndex].toSourceType === 3) {
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideToSourceMetaData = true;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideToHeader = true;
                        }
                        else {
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideToSourceMetaData = false;
                            newSourceList[index + 1].subSourceConfiguration[childIndex].showHideToHeader = false;
                        }
                    });
                });
                setAllSourceList(newSourceList);
            }
        }
    }

    const handleNextSubmit = async () => {
        if (accountNameId == undefined || accountNameId == 0) {
            showSnackbar("Please select Account Name", true);
        } else if (inputGroups.length === 1) {
            showSnackbar("Please Add the source", true);
        } else {

            allSourceList.forEach((element, index) => {
                if (nextStep !== 0) {
                    if (!validateSaveQuery(element)) {
                        handleNext();
                    }
                } else {
                    handleNext();
                }
            });
        }
    };

    const handleSubmit = async () => {
        if (allSourceList.length > 0) {
            let totalSourceList: any[] = [];
            allSourceList.forEach(async (element, index) => {
                if (index !== 0 && steps.length > index) {
                    if (validateSaveQuery(element)) {
                        return;
                    } else {
                        let fromSourceModel: FromSourceModel[] = [];
                        let subSourceModel: SubSourceModel[] = [];
                        element.fromSource.forEach((childElement: any, childIndex: number) => {
                            fromSourceModel.push({
                                fromSourceId: childElement.fromSourceId === 0 ? "" : childElement.fromSourceId,
                                accountMainSourceId: childElement.accountMainSourceId === 0 ? "" : childElement.accountMainSourceId,
                                fromSourceFileType: childElement.fromSourceFileType,
                                fromSourceLocationId1: childElement.fromSourceLocationId1,
                                fromSourceLocationId2: childElement.fromSourceLocationId2,
                                fromSourceMetadataDefinitionId: childElement.fromSourceMetadataDefinitionId === 0 ? null : childElement.fromSourceMetadataDefinitionId,
                                isFromSourceHeaderAvailable: childElement.isFromSourceHeaderAvailable
                            });
                        });

                        element.subSourceConfiguration.forEach((childElement: any, childIndex: number) => {
                            subSourceModel.push({
                                subSourceId: childElement.subSourceId === 0 ? "" : childElement.subSourceId,
                                accountMainSourceId: element.accountMainSourceId,
                                subSourceName: childElement.subSourceName,
                                level1FundFolderId: childElement.level1FundFolderId === 0 ? null : childElement.level1FundFolderId,
                                fromSourceType: childElement.fromSourceType,
                                fromSourceLocationId1: childElement.fromSourceLocationId1,
                                fromSourceLocationId2: childElement.fromSourceLocationId2 === 0 ? null : childElement.fromSourceLocationId2,
                                toSourceType: childElement.toSourceType,
                                toSourceFTPLocationId: childElement.toSourceFTPLocationId === 0 ? null : childElement.toSourceFTPLocationId,
                                fromSourceMetadataDefinitionId: childElement.fromSourceMetadataDefinitionId === 0 ? null : childElement.fromSourceMetadataDefinitionId,
                                toSourceMetadataDefinitionId: childElement.toSourceMetadataDefinitionId === 0 ? null : childElement.toSourceMetadataDefinitionId,
                                isFromSourceHeaderAvailable: childElement.isFromSourceHeaderAvailable,
                                isToSourceHeaderAvailable: childElement.isToSourceHeaderAvailable
                            });
                        });

                        const sourceConfigModel: SourceConfigModel = {
                            accountId: accountNameId ?? 0,
                            contextName: selectedAccountName ?? "",
                            sourceId: element.sourceId,
                            sourceName: inputGroups[index].sourceName,
                            level1FundFolderId: element.level1FundFolderId === 0 ? null : element.level1FundFolderId,
                            toSourceFileType: element.toSourceFileType === 0 ? null : element.toSourceFileType,
                            toSourceFTPLocationID: element.toSourceFTPLocationID === 0 ? null : element.toSourceFTPLocationID,
                            statusFTPLocationId: element.statusFTPLocationId === 0 ? null : element.statusFTPLocationId,
                            toSourceMetadataDefinitionId: element.toSourceMetadataDefinitionId === 0 ? null : element.toSourceMetadataDefinitionId,
                            isToSourceHeaderAvailable: element.isToSourceHeaderAvailable,
                            statusFileLocation: element.statusFileLocation,
                            fromSource: fromSourceModel,
                            subSource: subSourceModel,
                            txtType: element.txtType,
                            csvType: element.csvType,
                            xmlType: element.xmlType,
                            otherFileType: element.otherFileType === "" ? null : element.otherFileType,
                            accountMainSourceid: element.accountMainSourceId ?? 0,
                        }

                        totalSourceList.push(sourceConfigModel);

                        try {
                            setLoading(true);
                            const sourceList = { TotalSourceList: totalSourceList, RemoveSourceListItems: removeSourcelistItem };
                            let response = await AddSourceConfig(sourceList);
                            if (response) {
                                showSnackbar("Source Configuration Submitted Successfully");
                                handleReset();
                            }
                        } catch (error) {
                            showSnackbar("Error fetching data", true);
                        } finally {
                            setLoading(false);
                        }
                    }
                }
            });
        }
    }

    const handleReset = () => {
        setSteps([{ key: 'firstStep', label: 'Basic Information', isDone: true }]);
        setActiveStep({ key: 'firstStep', label: 'Basic Information', isDone: true });
        setNextStep(0);
        setAccountNameId(0);
        setInputGroups([{ subSystemName: '', sourceId: 0 }]);
        setAllSourceList(
            [{
                txtType: false,
                csvType: false,
                xmlType: false,
                otherType: false,
                otherTxtEnable: true,
                otherFileType: "",
                level1FundFolderId: 0,
                toSourceFileType: 0,
                toSourceFTPLocationID: 0,
                statusFTPLocationId: 0,
                sourceId: 0,
                sourceName: "",
                accountId: 0,
                accountMainSourceid: 0,
                toSourceMetadataDefinitionId: 0,
                isToSourceHeaderAvailable: 0,
                statusFileLocation: false,
                showHideExportLocation: false,
                subSourceConfiguration: [{
                    subSourceId: 0,
                    accountMainSourceId: 0,
                    subSourceName: "",
                    level1FundFolderId: 0,
                    fromSourceLocationId2: 0,
                    fromSourceMetadataDefinitionId: 0,
                    toSourceMetadataDefinitionId: 0,
                    isFromSourceHeaderAvailable: "",
                    isToSourceHeaderAvailable: "",
                    showHideSourceLocation: false,
                    showHideSourceMetaData: false,
                    showHideHeader: false,
                    showHideToSourceMetaData: false,
                    showHideToHeader: false,
                    panelLevel1Error: ""
                }],
                fromSource: [{ fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "", showHideSourceLocation: false, showHideSourceMetaData: false, showHideHeader: false }],
                showHideToSourceMetaData: false,
                showHideToHeader: false,
                level1Error: "",
                fromSourceTypeError: "",
                fileFormateError: "",
                toSourceMetadataError: ""
            }]
        );
    }

    const validateSaveQuery = (element: any): boolean => {
        let isError = [];
        if (element.level1FundFolderId === 0) {
            element.level1Error = "Please select the Level1";
            isError.push(true);
        } else {
            element.level1Error = "";
            isError.push(false);
        }
        element.fromSource.forEach((childElement: any, childIndex: number) => {
            if (childElement.fromSourceFileType === 0) {
                childElement.fromSourceTypeError = "Please select the From Source Type";
                isError.push(true);
            } else {
                childElement.fromSourceTypeError = "";
                isError.push(false);
            }
        });

        if (element.txtType === false && element.csvType === false && element.xmlType === false && element.otherType === false) {
            element.fileFormateError = "Please select file format";
            isError.push(true);
        } else {
            element.fileFormateError = "";
            isError.push(false);
        }
        return isError.includes(true);
    }

    const handleAccountNameChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setAccountNameId(Number(event.target.value));

        const newContextName = accountName.find((option) => option.businessUnitId === Number(event.target.value))?.contextName;
        setSelectedAccountName(newContextName);
        getSourceName(Number(event.target.value), newContextName);
        getActiveFileLocation(Number(event.target.value), newContextName);
        getMetadataColumns(Number(event.target.value), newContextName);
        setSteps([{ key: 'firstStep', label: 'Source Configuration', isDone: true }]);
        setInputGroups([{ sourceName: '', sourceId: 0 }]);
    }

    const handleSourceTypeChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedOptionText = event.target.options[event.target.selectedIndex].text;
        const updatedSourceList = [...allSourceList];
        if (selectedOptionText === "Metadata" || selectedOptionText === "Zip(PDF + Metadata)") {
            updatedSourceList[index].fromSource[childIndex].showHideSourceLocation = false;
            updatedSourceList[index].fromSource[childIndex].showHideSourceMetaData = true;
            updatedSourceList[index].fromSource[childIndex].showHideHeader = true;
        } else if (selectedOptionText === "PDF + Metadata") {
            updatedSourceList[index].fromSource[childIndex].showHideSourceLocation = true;
            updatedSourceList[index].fromSource[childIndex].showHideSourceMetaData = true;
            updatedSourceList[index].fromSource[childIndex].showHideHeader = true;
        } else {
            updatedSourceList[index].fromSource[childIndex].showHideSourceLocation = false;
            updatedSourceList[index].fromSource[childIndex].showHideSourceMetaData = false;
            updatedSourceList[index].fromSource[childIndex].showHideHeader = false;
        }
        updatedSourceList[index].fromSource[childIndex].fromSourceFileType = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSourceLocation1Change = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].fromSource[childIndex].fromSourceLocationId1 = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSourceLocation2Change = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].fromSource[childIndex].fromSourceLocationId2 = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleMetadataDefChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].fromSource[childIndex].fromSourceMetadataDefinitionId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlePanelSourceLocation1Change = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].fromSourceLocationId1 = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlePanelSourceLocation2Change = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].fromSourceLocation2 = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlePanelSourceMetadatDefChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].fromSourceMetadataDefinitionId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSubSourceConfigChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].level1FundFolderId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlePanelSourceTypeChange = (
        index: number, childIndex: number, event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const allSourceListData = [...allSourceList];
        const selectedOptionText = event.target.options[event.target.selectedIndex].text;
        if (selectedOptionText === "Metadata" || selectedOptionText === "Zip(PDF + Metadata)") {
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceLocation = false;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceMetaData = true;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideHeader = true;
        } else if (selectedOptionText === "PDF + Metadata") {
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceLocation = true;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceMetaData = true;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideHeader = true;
        } else {
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceLocation = false;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideSourceMetaData = false;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideHeader = false;
        }
        allSourceListData[index].subSourceConfiguration[childIndex].fromSourceType = Number(event.target.value);
        setAllSourceList(allSourceListData);
    }

    const handleToSourceTypeChange = (
        event: React.ChangeEvent<HTMLSelectElement>, index: number
    ) => {
        const selectedOptionText = event.target.options[event.target.selectedIndex].text;
        const updatedSourceList = [...allSourceList];
        if (selectedOptionText === "Metadata" || selectedOptionText === "Zip(PDF + Metadata)" || selectedOptionText === "PDF + Metadata") {
            updatedSourceList[index].showHideToSourceMetaData = true;
            updatedSourceList[index].showHideToHeader = true;
        }
        else {
            updatedSourceList[index].showHideToSourceMetaData = false;
            updatedSourceList[index].showHideToHeader = false;
        }
        updatedSourceList[index].toSourceFileType = event.target.value;
        setAllSourceList(updatedSourceList);
    }

    const handlePanelToSourceTypeChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedOptionText = event.target.options[event.target.selectedIndex].text;
        const allSourceListData = [...allSourceList];
        if (selectedOptionText === "Metadata" || selectedOptionText === "Zip(PDF + Metadata)" || selectedOptionText === "PDF + Metadata") {
            allSourceListData[index].subSourceConfiguration[childIndex].showHideToSourceMetaData = true;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideToHeader = true;
        }
        else {
            allSourceListData[index].subSourceConfiguration[childIndex].showHideToSourceMetaData = false;
            allSourceListData[index].subSourceConfiguration[childIndex].showHideToHeader = false;
        }
        allSourceListData[index].subSourceConfiguration[childIndex].toSourceType = Number(event.target.value);
        setAllSourceList(allSourceListData);
    }

    const handlePanelSourceMetadataChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].toSourceMetadataDefinitionId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlePanelToSourceLocationChange = (index: number, childIndex: number,
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].toSourceFTPLocationId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }
    const getFolders = async () => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: selectedAccountName,
        };
        try {
            const response = await GetFolders(payload);
            const { enabledFundFolders = [] } = response;
            if (enabledFundFolders.length > 0) {
                setLevel(enabledFundFolders);
            }
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    };

    const getSourceName = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        setInputGroups([{ sourceName: '', sourceId: 0 }]);
        const payload: any = {
            accountId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const response = await GetSourceDetails(payload);
            const { totalSourceList = [] } = response;
            if (totalSourceList.length > 0) {
                setTotalSourceList(totalSourceList);
                const newInputGroups = totalSourceList.map((source: any) => {
                    return { sourceName: source.sourceName, sourceId: source.sourceId };
                });
                // Prepend an object with an empty sourceName value
                newInputGroups.unshift({ sourceName: '', sourceId: 0 });
                setInputGroups(newInputGroups);
            }
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    };

    const getActiveFileLocation = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const activeFileLocationData = await GetActiveFileLocation(payload);
            setActiveFileLocation(activeFileLocationData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setLoading(false);
        }
    };

    const getMetadataColumns = async (accountNameId: number, accountName: string) => {
        setLoading(true);
        const payload: any = {
            businessUnitId: Number(accountNameId),
            contextName: accountName,
        };
        try {
            const metadataColumnsData = await GetMetadataColumns(payload);
            setMetadataColumns(metadataColumnsData);
        } catch (error) {
            showSnackbar("Error fetching data", true);
        } finally {
            setLoading(false);
        }
    };

    const handleAddInputGroup = (index: number) => {
        if (inputGroups[index].sourceName === '') {
            showSnackbar("Please enter Source Name", true);
        } else {
            const newInputGroups = [{ sourceName: '', sourceId: 0 }, ...inputGroups];
              // Move the item with sourceId = 0 to the end of the array
            const sortedInputGroups = newInputGroups.filter(item => item.sourceId !== 1).concat(newInputGroups.filter(item => item.sourceId === 1));
            setInputGroups(sortedInputGroups);
        }
    }

    const handleDeleteSource = (index: number, key: string, sourceId: number) => {
        setDialogProps({
            dialogTitle: "Delete Confirmation",
            contentText: "Are you sure you want to delete this Source?",
            confirmText: "Yes",
            closeText: "No",
            onConfirm: async () => await handleDeleteInputGroup(index, key, sourceId),
        });
        setDialogOpen(true);
    }

    const handleDeleteInputGroup = async (index: number, key: string, sourceId: number): Promise<void> => {
        const newInputGroups = inputGroups.filter((_, i) => i !== index);
        const newSteps = steps.filter(step => step.key !== key);
        const newAllSubSystemConfig = allSourceList.filter((_, i) => i !== index);
        setAllSourceList(newAllSubSystemConfig);
        const newTotalSourceList = totalSourceList.filter((item, i) => item.sourceName !== key);
        setTotalSourceList(newTotalSourceList);
        setInputGroups(newInputGroups);
        setSteps(newSteps);
        setDialogOpen(false);
        const listItem= removeSourcelistItem;
        listItem.push(sourceId);
        setRemoveSourceListItem(listItem);
        
    };

    const handleAddSourceType = (index: number) => {
        const allSourceListData = [...allSourceList];
        allSourceListData[index].fromSource = [...allSourceListData[index].fromSource, { fromSourceId: 0, accountMainSourceId: 0, fromSourceFileType: 0, fromSourceLocationId1: 0, fromSourceLocationId2: 0, fromSourceMetadataDefinitionId: 0, isFromSourceHeaderAvailable: "" }];
        setAllSourceList(allSourceListData);
    }
    const handleDeleteSourceType = (index: number, childIndex: number) => {
        if (fromSource.length > 1 || index !== 0) {
            //Remove Text control
            const allSourceListData = [...allSourceList];
            allSourceListData[index].fromSource = allSourceListData[index].fromSource.filter((_: any, i: number) => i !== childIndex);
            setAllSourceList(allSourceListData);
        } else {
            let sourceItem = fromSource;
            sourceItem[index].fromSourceFileType = 0;
            sourceItem[index].fromSourceLocationId1 = 0;
            sourceItem[index].fromSourceLocationId2 = 0;
            sourceItem[index].fromSourceMetadataDefinitionId = 0;
            sourceItem[index].isFromSourceHeaderAvailable = "";
            setFromSource(sourceItem)
        }
    }

    const handleSearchChange = (index: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newInputGroups = [...inputGroups];
        newInputGroups[index].sourceName = event.target.value;
        newInputGroups[index].sourceId = 1;
        setInputGroups(newInputGroups);
    };

    const handleBack = () => {
        const index = steps.findIndex(x => x.key === activeStep.key);
        if (index === 0) return;

        setSteps(prevStep => prevStep.map(x => {
            if (x.key === activeStep.key) x.isDone = false;
            return x;
        }))
        setActiveStep(steps[index - 1]);
        setNextStep(nextStep - 1);
    }

    const handleExportLocationChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        if (event.target.checked) {
            updatedSourceList[index].statusFileLocation = event.target.checked;
            updatedSourceList[index].showHideExportLocation = true;
        } else {
            updatedSourceList[index].statusFileLocation = event.target.checked;
            updatedSourceList[index].showHideExportLocation = false;
        }
        setAllSourceList(updatedSourceList);
    }

    const handleFtpLocationChange = (index: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].statusFTPLocationId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleAddSubConfig = (index: number, subSourceChildindex: number) => {
        const allSourceListData = [...allSourceList];
        if (allSourceListData[index].subSourceConfiguration[subSourceChildindex].subSourceName === '') {
            showSnackbar("Please enter Sub Source Name", true);
        } else {
            const allSourceListData = [...allSourceList];
            allSourceListData[index].subSourceConfiguration = [...allSourceListData[index].subSourceConfiguration, {
                subSourceId: 0,
                accountMainSourceId: 0,
                subSourceName: "",
                level1FundFolderId: 0,
                fromSourceLocationId2: 0,
                fromSourceMetadataDefinitionId: 0,
                toSourceMetadataDefinitionId: 0,
                isFromSourceHeaderAvailable: "",
                isToSourceHeaderAvailable: "",
                showHideSourceLocation: false,
                showHideSourceMetaData: false,
                showHideHeader: false,
                showHideToSourceMetaData: false,
                showHideToHeader: false
            }];
            setAllSourceList(allSourceListData);
        }
    }

    const handleDeleteSubConfig = (index: number, childIndex: number) => {
        const allSourceListData = [...allSourceList];
        if (allSourceListData[index].subSourceConfiguration.length > 1 || childIndex !== 0) {
            //Remove Text control            
            allSourceListData[index].subSourceConfiguration = allSourceListData[index].subSourceConfiguration.filter((_: any, i: number) => i !== childIndex);
        } else {
            allSourceListData[index].subSourceConfiguration[childIndex].subSourceName = '';
            allSourceListData[index].subSourceConfiguration[childIndex].subSourceId = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].accountMainSourceId = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].subSourceName = "";
            allSourceListData[index].subSourceConfiguration[childIndex].level1FundFolderId = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].fromSourceLocationId2 = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].fromSourceMetadataDefinitionId = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].toSourceMetadataDefinitionId = 0;
            allSourceListData[index].subSourceConfiguration[childIndex].isFromSourceHeaderAvailable = "";
            allSourceListData[index].subSourceConfiguration[childIndex].isToSourceHeaderAvailable = "";
        }
        setAllSourceList(allSourceListData);
    }

    const handleSubSourceChange = (index: number, subSourceChildindex: number, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const allSourceListData = [...allSourceList];
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].subSourceName = event.target.value;
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].showHideSourceLocation = false;
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].showHideSourceMetaData = false;
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].showHideToSourceMetaData = false;
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].showHideHeader = false;
        allSourceListData[index].subSourceConfiguration[subSourceChildindex].showHideToHeader = false;
        setAllSourceList(allSourceListData);
    }

    const handleTxtChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].txtType = event.target.checked;
        setAllSourceList(updatedSourceList);
    }

    const handleCsvChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].csvType = event.target.checked;
        setAllSourceList(updatedSourceList);
    }

    const handleXmlChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].xmlType = event.target.checked;
        setAllSourceList(updatedSourceList);
    }

    const handleOtherTypeChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const updatedSourceList = [...allSourceList];
            updatedSourceList[index].otherType = event.target.checked;
            updatedSourceList[index].otherTxtEnable = false;
            setAllSourceList(updatedSourceList);
        } else {
            const updatedSourceList = [...allSourceList];
            updatedSourceList[index].otherType = event.target.checked;
            updatedSourceList[index].otherTxtEnable = true;
            setAllSourceList(updatedSourceList);
        }
    }

    const handleOtherTxtChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].otherFileType = event.target.value;
        setAllSourceList(updatedSourceList);
    }

    const handleLevel1Change = (index: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].level1FundFolderId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSourceLocationChange = (index: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].toSourceFTPLocationID = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSourceMetadataChange = (index: number, event: React.ChangeEvent<HTMLSelectElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].toSourceMetadataDefinitionId = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleHeaderChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].fromSource[childIndex].isFromSourceHeaderAvailable = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleSourceHeaderChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].isToSourceHeaderAvailable = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handlesubSourceHeaderChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {   
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].isFromSourceHeaderAvailable = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    const handleToSubSourceHeaderChange = (index: number, childIndex: number, event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedSourceList = [...allSourceList];
        updatedSourceList[index].subSourceConfiguration[childIndex].isToSourceHeaderAvailable = Number(event.target.value);
        setAllSourceList(updatedSourceList);
    }

    return (
        <div >
            <NavigationBar menuTitle="Configuration" title="Configuration Source" text="Source Configuration" screenTitle="Create" />
            <div className="box">
                <div className="steps" style={{ marginLeft: "20px" }}>
                    <ul className="nav">
                        {steps.map((step, i) => {
                            return <li key={step.key} className={`${activeStep.key === step.key ? 'active' : ''} ${step.isDone ? 'done' : ''}`}>
                                {activeStep.key === step.key ?
                                    <div className={styles.activeClass}>
                                        <span>Step</span> <span>{i + 1}</span>
                                        <br />
                                        <span>{step.label}</span>
                                    </div> :
                                    <div className={`${i == 0 ? styles.deactiveClass : styles.deactiveClassChild}`}>
                                        <span>Step</span> <span style={{ marginLeft: "10px" }}>{i + 1}</span>
                                    </div>
                                }
                            </li>
                        })}
                    </ul>
                </div>
                <div className="step-component">
                    {nextStep === 0 && (
                        <Form>
                            <Row className="mb-3" style={{ display: "block" }}>
                                <Col md={3}>
                                    <Form.Group controlId="formCustomer">
                                        <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                            Account Name<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            name="customerId"
                                            value={accountNameId}
                                            onChange={handleAccountNameChange}
                                            style={{fontSize:"11px"}}
                                            data-testid="accountName"
                                        >
                                            <option value="0">Select</option>
                                            {accountName.map((accName: any) => (
                                                <option key={accName.businessUnitId} value={accName.businessUnitId}>
                                                    {accName.accountName}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {inputGroups.map((inputGroup, index) => (
                                    <Col style={{ marginTop: "15px" }}>
                                        <Form.Group controlId="formGroupName" style={{ display: "inline-block", width: "24%" }}>
                                            { index === 0 && (<Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                Source Name<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                            </Form.Label>)}
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Source Name"
                                                value={inputGroup.sourceName}
                                                id={`txtSourceName_${index}`}
                                                name={inputGroup.sourceName}
                                                onChange={(event) => handleSearchChange(index, event)}
                                                required
                                                style={{fontSize:"11px"}}
                                            />
                                        </Form.Group>
                                        {index === 0 && (<AddBoxIcon
                                            style={{ marginLeft: "10px", color: "var(--button-color)" }}
                                            onClick={() => handleAddInputGroup(index)}>
                                        </AddBoxIcon>)}
                                        {index !== 0 && (<DeleteForeverIcon
                                            style={{ marginLeft: "10px", color: "var(--button-color)" }}
                                            onClick={() => handleDeleteSource(index, inputGroup.sourceName, inputGroup.sourceId)}>
                                        </DeleteForeverIcon>)}
                                    </Col>
                                ))}

                                <ConfirmationDialog
                                    open={dialogOpen}
                                    onConfirm={dialogProps.onConfirm}
                                    onClose={setDialogOpen.bind(this, false)}
                                    contentText={dialogProps.contentText}
                                    closeText={dialogProps.closeText}
                                    confirmText={dialogProps.confirmText}
                                    dialogTitle={dialogProps.dialogTitle}
                                />
                            </Row>
                            <Button
                                variant="outlined"
                                type="button"
                                onClick={handleNextSubmit}
                                color="primary"
                                className={styles.btnClass}
                            >
                                Next
                            </Button>
                        </Form>)}
                    {nextStep !== 0 && (
                        <div>
                            <Button
                                variant="outlined"
                                type="button"
                                onClick={handleBack}
                                color="primary"
                                className={styles.btnClass}
                            >
                                Previous
                            </Button>
                            {nextStep !== steps.length - 1 && (<Button
                                variant="outlined"
                                type="button"
                                onClick={handleNextSubmit}
                                className={styles.btnClass}
                                style={{ marginLeft: "10px" }}
                            >
                                Next
                            </Button>)}
                            {allSourceList.map((sourceList, index) => (
                                <>
                                    {index === nextStep && (
                                        <div>
                                            <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)",fontSize:"12px" }}>METADATA FILE CONFIGURATION <span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span></h4>
                                            <form>
                                                <Row className="mb-6">
                                                    <Col md={6}>
                                                        <Form.Group controlId="formCustomer">
                                                            <span className="input-labels" style={{ display: "flex", color: "var(--aggrid-text-color)" }}>
                                                                <span style={{ marginTop: "10px",fontSize:"11px" }}>File formats : </span>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    label="TXT"
                                                                    name={`$fileFormats_${index}`}
                                                                    value={sourceList.txtType}
                                                                    style={{ marginLeft: "8px", marginTop: "10px",fontSize:"11px" }}
                                                                    checked={sourceList.txtType}
                                                                    onChange={(event) => handleTxtChange(index, event)}
                                                                />
                                                                <Form.Check
                                                                    data-testid="csv-check"
                                                                    type="checkbox"
                                                                    label="CSV"
                                                                    name="fileFormats"
                                                                    value={sourceList.csvType}
                                                                    style={{ marginLeft: "8px", marginTop: "10px",fontSize:"11px" }}
                                                                    checked={sourceList.csvType}
                                                                    onChange={(event) => handleCsvChange(index, event)}
                                                                />
                                                                <Form.Check
                                                                    data-testid="xml-check"
                                                                    type="checkbox"
                                                                    label="XML"
                                                                    name="fileFormats"
                                                                    value={sourceList.xmlType}
                                                                    style={{ marginLeft: "8px", marginTop: "10px",fontSize:"11px" }}
                                                                    checked={sourceList.xmlType}
                                                                    onChange={(event) => handleXmlChange(index, event)}
                                                                />
                                                                <Form.Check
                                                                    data-testid="other-check"
                                                                    type="checkbox"
                                                                    name="fileFormats"
                                                                    value="other"
                                                                    style={{ marginLeft: "8px", marginTop: "10px",fontSize:"11px"}}
                                                                    checked={sourceList.otherType}
                                                                    onChange={(event) => handleOtherTypeChange(index, event)}
                                                                />
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Other"
                                                                    name={`otherFileType_${index}`}
                                                                    value={sourceList.otherFileType}
                                                                    style={{ marginLeft: "5px", display: "inline-block", width: "30%",fontSize:"11px", height: "25px", marginTop: "5px" }}
                                                                    disabled={sourceList.otherTxtEnable}
                                                                    onChange={(event) => handleOtherTxtChange(event, index)} />
                                                            </span>
                                                        </Form.Group>
                                                        {sourceList.fileFormateError && (<span style={{ color: "red" }}>
                                                            {sourceList.fileFormateError}
                                                        </span>)}
                                                    </Col>
                                                </Row>
                                                <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)" ,fontSize:"12px"}}>INPUT SETTINGS</h4>
                                                <Row className="mb3">
                                                    <Col md={3}>
                                                        <Form.Group controlId="formCustomer">
                                                            <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                Level 1<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="level1"
                                                                value={sourceList.level1FundFolderId}
                                                                onChange={(event) => handleLevel1Change(index, event)}
                                                                style={{fontSize:"11px"}}
                                                            >
                                                                <option value="0">Select</option>
                                                                {level.map((level: any) => (
                                                                    <option key={level.fundFolderId} value={level.fundFolderId}>
                                                                        {level.folderName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {sourceList.level1Error && (<span style={{ color: "red" }}>
                                                                {sourceList.level1Error}
                                                            </span>)}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {sourceList.fromSource.map((fromSources: any, childIndex: number) => (
                                                    <Row className="mb12" style={{ marginTop: "10px" }}>
                                                        <Col md={3}>
                                                            <Form.Group controlId="formCustomer">
                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                    From Source Type<span style={{ color: "var(--aggrid-text-color)" }} className="required">*</span>
                                                                </Form.Label>
                                                                <Form.Select
                                                                    data-testid="fromSourceType"
                                                                    name="fromSourceType"
                                                                    value={fromSources.fromSourceFileType}
                                                                    onChange={(event) => handleSourceTypeChange(index, childIndex, event)}  style={{fontSize:"11px"}}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {sourceTypes.map((sourceType: any) => (
                                                                        <option key={sourceType.id} value={sourceType.id}>
                                                                            {sourceType.name}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                                {fromSources.fromSourceTypeError && (<span style={{ color: "red" }}>
                                                                    {fromSources.fromSourceTypeError}
                                                                </span>)}
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md={3}>
                                                            <Form.Group controlId="formCustomer">
                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                    From Source Location 1
                                                                </Form.Label>
                                                                <Form.Select
                                                                    data-testid="fromSourceLocation1"
                                                                    name="fromSourceLocation1"
                                                                    value={fromSources.fromSourceLocationId1}
                                                                    onChange={(event) => handleSourceLocation1Change(index, childIndex, event)}  style={{fontSize:"11px"}}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {activeFileLocations.map((activeFileLocation: any) => (
                                                                        <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                            {activeFileLocation.folderName}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        {fromSources.showHideSourceLocation && (<Col md={3}>
                                                            <Form.Group controlId="formCustomer">
                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                    From Source Location 2
                                                                </Form.Label>
                                                                <Form.Select
                                                                    name="fromSourceLocation2"
                                                                    value={fromSources.fromSourceLocationId2}
                                                                    onChange={(event) => handleSourceLocation2Change(index, childIndex, event)}  style={{fontSize:"11px"}}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {activeFileLocations.map((activeFileLocation: any) => (
                                                                        <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                            {activeFileLocation.folderName}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>)}
                                                        {fromSources.showHideSourceMetaData && (<Col md={3}>
                                                            <Form.Group controlId="formCustomer">
                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                    From Source Metadata Definition
                                                                </Form.Label>
                                                                <Form.Select
                                                                    name="fromSourceMetadataDefinition"
                                                                    value={fromSources.fromSourceMetadataDefinitionId}
                                                                    onChange={(event) => handleMetadataDefChange(index, childIndex, event)}  style={{fontSize:"11px"}}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {metadataColumns.map((metadataColumn: any) => (
                                                                        <option key={metadataColumn.metadataDefinitionId} value={metadataColumn.metadataDefinitionId}>
                                                                            {metadataColumn.metadataDefinitionName}
                                                                        </option>
                                                                    ))}
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>)}
                                                        {fromSources.showHideHeader && (
                                                            <Col md={3} style={{ marginTop: "5px", width: "125px", color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                Header
                                                                <span style={{ display: "flex" }}>
                                                                    <Form.Check
                                                                        type="radio"
                                                                        name={`fromHeader_${childIndex}`}
                                                                        value="1"
                                                                        label="Yes"
                                                                        style={{ marginTop: "10px" }}
                                                                        checked={fromSources.isFromSourceHeaderAvailable === 1}
                                                                        onChange={(event) => handleHeaderChange(index, childIndex, event)}
                                                                    />
                                                                    <Form.Check
                                                                        type="radio"
                                                                        name={`fromHeader_${childIndex}`}
                                                                        value="0"
                                                                        label="No"
                                                                        style={{ marginLeft: "8px", marginTop: "10px" }}
                                                                        checked={fromSources.isFromSourceHeaderAvailable === 0}
                                                                        onChange={(event) => handleHeaderChange(index, childIndex, event)}
                                                                    />
                                                                </span>
                                                            </Col>
                                                        )}
                                                        {childIndex === allSourceList[index].fromSource.length - 1 && (<AddBoxIcon
                                                            style={{ marginTop: "40px", paddingLeft: "0px", paddingRight: "0px", color: "var(--button-color)" }}
                                                            onClick={() => handleAddSourceType(index)}
                                                        >
                                                        </AddBoxIcon>)}
                                                        {childIndex !== 0 && (<DeleteForeverIcon
                                                            style={{ marginLeft: "10px", paddingLeft: "0px", paddingRight: "0px", marginTop: "40px", color: "var(--button-color)" }}
                                                            onClick={() => handleDeleteSourceType(index, childIndex)}
                                                        >
                                                        </DeleteForeverIcon>)}
                                                    </Row>))}
                                                <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)",fontSize:"12px" }}>OUTPUT SETTINGS</h4>
                                                <Row className="mb3" style={{ marginTop: "10px" }}>
                                                    <Col md={3}>
                                                        <Form.Group controlId="formCustomer">
                                                            <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                To Source Type
                                                            </Form.Label>
                                                            <Form.Select
                                                                data-testid="toSourceType"
                                                                name="fromSourceType"
                                                                value={sourceList.toSourceFileType}
                                                                onChange={(event) => handleToSourceTypeChange(event, index)}  style={{fontSize:"11px"}}
                                                            >
                                                                <option value="">Select</option>
                                                                {sourceTypes.map((sourceType: any) => (
                                                                    <option key={sourceType.id} value={sourceType.id}>
                                                                        {sourceType.name}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={3}>
                                                        <Form.Group controlId="formCustomer">
                                                            <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                To Source Location
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="fromSourceLocation1"
                                                                value={sourceList.toSourceFTPLocationID}
                                                                onChange={(event) => handleSourceLocationChange(index, event)}  style={{fontSize:"11px"}}
                                                            >
                                                                <option value="">Select</option>
                                                                {activeFileLocations.map((activeFileLocation: any) => (
                                                                    <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                        {activeFileLocation.folderName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {sourceList.showHideToSourceMetaData && (<Col md={3}>
                                                        <Form.Group controlId="formCustomer">
                                                            <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                To Source Metadata Definition
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="toSourceMetadataDefinition"
                                                                value={sourceList.toSourceMetadataDefinitionId}
                                                                onChange={(event) => handleSourceMetadataChange(index, event)}  style={{fontSize:"11px"}}
                                                            >
                                                                <option value="">Select</option>
                                                                {metadataColumns.map((metadataColumn: any) => (
                                                                    <option key={metadataColumn.metadataDefinitionId} value={metadataColumn.metadataDefinitionId}>
                                                                        {metadataColumn.metadataDefinitionName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>)}
                                                    {sourceList.showHideToHeader && (<Col md={3} style={{ marginTop: "5px", color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                        Header
                                                        <span style={{ display: "flex" }}>
                                                            <Form.Check
                                                                type="radio"
                                                                name={`toHeader_${index}`}
                                                                value="1"
                                                                label="Yes"
                                                                style={{ marginTop: "10px" }}
                                                                checked={sourceList.isToSourceHeaderAvailable === 1}
                                                                onChange={(event) => handleSourceHeaderChange(index, event)}
                                                            />
                                                            <Form.Check
                                                                type="radio"
                                                                name={`toHeader_${index}`}
                                                                value="0"
                                                                label="No"
                                                                style={{ marginLeft: "8px", marginTop: "10px" }}
                                                                checked={sourceList.isToSourceHeaderAvailable === 0}
                                                                onChange={(event) => handleSourceHeaderChange(index, event)}
                                                            />
                                                        </span>
                                                    </Col>)}
                                                </Row>
                                                <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)", fontSize:"12px" }}>STATUS SETTINGS</h4>
                                                <Row className="mb-6">
                                                    <Col md={6}>
                                                        <Form.Group controlId="formCustomer">
                                                            <span className="input-labels" style={{ display: "flex", color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    label="Status File Location"
                                                                    name="statusFileLocation"
                                                                    value="false"
                                                                    onChange={(event) => handleExportLocationChange(index, event)}
                                                                    checked={sourceList.statusFileLocation}
                                                                />
                                                            </span>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {sourceList.showHideExportLocation && (<Row className="mb-3">
                                                    <Col md={3}>
                                                        <Form.Group controlId="formCustomer">
                                                            <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)" ,fontSize:"11px" }}>
                                                                Status Export Location
                                                            </Form.Label>
                                                            <Form.Select
                                                                name="statusFtpLocation"
                                                                value={sourceList.statusFTPLocationId}
                                                                onChange={(event) => handleFtpLocationChange(index, event)}  style={{fontSize:"11px"}}
                                                            >
                                                                <option value="">Select</option>
                                                                {activeFileLocations.map((activeFileLocation: any) => (
                                                                    <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                        {activeFileLocation.folderName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>)}
                                                {sourceList.subSourceConfiguration.map((subSourceConfig: any, subSourceChildindex: number) => (
                                                    <Row className="mb-4" style={{ marginTop: "10px" }}>
                                                        <Col md={4}>
                                                            <Form.Group controlId="formGroupName" style={{ display: "inline-block", width: "75%" }}>
                                                                {subSourceChildindex === 0 && (<Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"12px" }}>
                                                                    SUB SOURCE CONFIGURATION
                                                                </Form.Label>)}
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter SubSource Name"
                                                                    name="cc"
                                                                    value={subSourceConfig.subSourceName || ""}
                                                                    onChange={(event) => handleSubSourceChange(index, subSourceChildindex, event)}  style={{fontSize:"11px"}}
                                                                />
                                                            </Form.Group>
                                                            {subSourceChildindex === allSourceList[index].subSourceConfiguration.length - 1 && (<AddBoxIcon
                                                                style={{ marginLeft: "10px", color: "var(--button-color)" }}
                                                                onClick={() => handleAddSubConfig(index, subSourceChildindex)}
                                                            >
                                                            </AddBoxIcon>)}
                                                            <DeleteForeverIcon
                                                                style={{ marginLeft: "10px", color: "var(--button-color)" }}
                                                                onClick={() => handleDeleteSubConfig(index, subSourceChildindex)}
                                                            >
                                                            </DeleteForeverIcon>
                                                        </Col>
                                                    </Row>))}
                                                {sourceList.subSourceConfiguration.map((subSourceConfig: any, subSourceChildindex: number) => (
                                                    <>
                                                        {subSourceConfig.subSourceName !== "" && (
                                                            <Accordion style={{ marginBottom: "20px" }}>
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    aria-controls="panel1-content"
                                                                    id="panel1-header"
                                                                    style={{ fontSize: "18px", fontWeight: "bold" }}
                                                                >
                                                                    {subSourceConfig.subSourceName}
                                                                </AccordionSummary>
                                                                <AccordionDetails style={{ backgroundColor: "var(--primary-color)" }}>
                                                                    <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)" }}>INPUT SETTINGS</h4>
                                                                    <Row className="mb3">
                                                                        <Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    Level 1
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="level1"
                                                                                    value={subSourceConfig.level1FundFolderId}
                                                                                    onChange={(event) => handleSubSourceConfigChange(index, subSourceChildindex, event)}  style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {level.map((level: any) => (
                                                                                        <option key={level.fundFolderId} value={level.fundFolderId}>
                                                                                            {level.folderName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className="mb12" style={{ marginTop: "10px" }}>
                                                                        <Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    From Source Type
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="fromSourceType"
                                                                                    value={subSourceConfig.fromSourceType}
                                                                                    onChange={(event) => handlePanelSourceTypeChange(index, subSourceChildindex, event)}  style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {sourceTypes.map((sourceType: any) => (
                                                                                        <option key={sourceType.id} value={sourceType.id}>
                                                                                            {sourceType.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    From Source Location 1
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="fromSourceLocation1"
                                                                                    value={subSourceConfig.fromSourceLocationId1}
                                                                                    onChange={(event) => handlePanelSourceLocation1Change(index, subSourceChildindex, event)} style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {activeFileLocations.map((activeFileLocation: any) => (
                                                                                        <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                                            {activeFileLocation.folderName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        {subSourceConfig.showHideSourceLocation && (<Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    From Source Location 2
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="fromSourceLocation2"
                                                                                    value={subSourceConfig.fromSourceLocationId2}
                                                                                    onChange={(event) => handlePanelSourceLocation2Change(index, subSourceChildindex, event)} style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {activeFileLocations.map((activeFileLocation: any) => (
                                                                                        <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                                            {activeFileLocation.folderName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>)}
                                                                        {subSourceConfig.showHideSourceMetaData && (<Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    From Source Metadata Definition
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="fromSourceMetadataDefinition"
                                                                                    value={subSourceConfig.fromSourceMetadataDefinitionId}
                                                                                    onChange={(event) => handlePanelSourceMetadatDefChange(index, subSourceChildindex, event)} style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {metadataColumns.map((metadataColumn: any) => (
                                                                                        <option key={metadataColumn.metadataDefinitionId} value={metadataColumn.metadataDefinitionId}>
                                                                                            {metadataColumn.metadataDefinitionName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>)}
                                                                        {subSourceConfig.showHideHeader && (<Col md={3} style={{ color: "var(--aggrid-text-color)", marginTop: "5px",fontSize:"11px" }}>
                                                                            Header
                                                                            <span style={{ display: "flex" }}>
                                                                                <Form.Check
                                                                                    type="radio"
                                                                                    name="fromHeader"
                                                                                    value="1"
                                                                                    label="Yes"
                                                                                    style={{ marginTop: "10px" }}
                                                                                    checked={subSourceConfig.isFromSourceHeaderAvailable === 1}
                                                                                    onChange={(event) => handlesubSourceHeaderChange(index, subSourceChildindex, event)}
                                                                                />
                                                                                <Form.Check
                                                                                    type="radio"
                                                                                    name="fromHeader"
                                                                                    value="0"
                                                                                    label="No"
                                                                                    style={{ marginLeft: "8px", marginTop: "10px" }}
                                                                                    checked={subSourceConfig.isFromSourceHeaderAvailable === 0}
                                                                                    onChange={(event) => handlesubSourceHeaderChange(index, subSourceChildindex, event)}
                                                                                />
                                                                            </span>
                                                                        </Col>)}
                                                                    </Row>
                                                                    <h4 className="form-heading" style={{ color: "var(--aggrid-text-color)", fontSize:"12px" }}>OUTPUT SETTINGS</h4>
                                                                    <Row className="mb3" style={{ marginTop: "10px" }}>
                                                                        <Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    To Source Type
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="fromSourceType"
                                                                                    value={subSourceConfig.toSourceType}
                                                                                    onChange={(event) => handlePanelToSourceTypeChange(index, subSourceChildindex, event)}  style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {sourceTypes.map((sourceType: any) => (
                                                                                        <option key={sourceType.id} value={sourceType.id}>
                                                                                            {sourceType.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    To Source Location
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="toSourceLocation1"
                                                                                    value={subSourceConfig.toSourceFTPLocationId}
                                                                                    onChange={(event) => handlePanelToSourceLocationChange(index, subSourceChildindex, event)}  style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {activeFileLocations.map((activeFileLocation: any) => (
                                                                                        <option key={activeFileLocation.ftpFolderId} value={activeFileLocation.ftpFolderId}>
                                                                                            {activeFileLocation.folderName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>
                                                                        {subSourceConfig.showHideToSourceMetaData && (<Col md={3}>
                                                                            <Form.Group controlId="formCustomer">
                                                                                <Form.Label className="input-labels" style={{ color: "var(--aggrid-text-color)",fontSize:"11px" }}>
                                                                                    To Source Metadata Definition
                                                                                </Form.Label>
                                                                                <Form.Select
                                                                                    name="toSourceMetadataDefinition"
                                                                                    value={subSourceConfig.toSourceMetadataDefinitionId}
                                                                                    onChange={(event) => handlePanelSourceMetadataChange(index, subSourceChildindex, event)} style={{fontSize:"11px"}}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    {metadataColumns.map((metadataColumn: any) => (
                                                                                        <option key={metadataColumn.metadataDefinitionId} value={metadataColumn.metadataDefinitionId}>
                                                                                            {metadataColumn.metadataDefinitionName}
                                                                                        </option>
                                                                                    ))}
                                                                                </Form.Select>
                                                                            </Form.Group>
                                                                        </Col>)}
                                                                        {subSourceConfig.showHideToHeader && (<Col md={3} style={{ color: "var(--aggrid-text-color)", marginTop: "5px",fontSize:"11px" }}>
                                                                            Header
                                                                            <span style={{ display: "flex" }}>
                                                                                <Form.Check
                                                                                    type="radio"
                                                                                    name="toHeader"
                                                                                    value="1"
                                                                                    label="Yes"
                                                                                    style={{ marginTop: "10px" }}
                                                                                    checked={subSourceConfig.isToSourceHeaderAvailable === 1}
                                                                                    onChange={(event) => handleToSubSourceHeaderChange(index, subSourceChildindex, event)}
                                                                                />
                                                                                <Form.Check
                                                                                    type="radio"
                                                                                    name="toHeader"
                                                                                    value="0"
                                                                                    label="No"
                                                                                    style={{ marginLeft: "8px", marginTop: "10px" }}
                                                                                    checked={subSourceConfig.isToSourceHeaderAvailable === 0}
                                                                                    onChange={(event) => handleToSubSourceHeaderChange(index, subSourceChildindex, event)}
                                                                                />
                                                                            </span>
                                                                        </Col>)}
                                                                    </Row>
                                                                </AccordionDetails>
                                                            </Accordion>)}
                                                    </>))}
                                            </form>
                                        </div>)}
                                </>
                            ))}
                            {nextStep !== 0 && (<Button
                                variant="outlined"
                                type="button"
                                onClick={handleBack}
                                color="primary"
                                className={styles.btnClass}
                            >
                                Previous
                            </Button>)}
                            {nextStep !== steps.length - 1 && (<Button
                                variant="outlined"
                                type="button"
                                onClick={handleNextSubmit}
                                className={styles.btnClass}
                                style={{ marginLeft: "10px" }}
                            >
                                Next
                            </Button>)}
                            {nextStep === steps.length - 1 && (<Button
                                variant="outlined"
                                type="button"
                                onClick={handleSubmit}
                                className={styles.btnClass}
                                style={{ marginLeft: "10px" }}
                            >
                                Submit
                            </Button>)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SourceConfiguration;